import apiClient from "./apiClient";
import {
  DigestChangePasswordRequest,
  ChangePasswordResponse,
} from "./Models/AuthModel";
import { AxiosResponse } from "axios";
import { Cript } from "../utils/cript";

export const changePassword = async (
  securityToken: string | null,
  userName: string,
  oldPassword: string,
  newPassword: string,
  activationCode?: string,
  language?: string
): Promise<ChangePasswordResponse> => {
  let salt = "";
  let oldDigest: string | null = "";
  let newDigest: string | null = "";
  if (activationCode) {
    let key: string | null =
      Cript.trim(userName).toLowerCase() +
      Cript.trim(newPassword).toLowerCase();
    key = Cript.sha1EsaDigest(key, key.length);
    if (key) newDigest = key;
    securityToken = null;
  } else {
    salt = Cript.getSalt().toLowerCase();
    let key: string | null =
      Cript.trim(userName).toLowerCase() +
      Cript.trim(oldPassword).toLowerCase();
    key = Cript.sha1EsaDigest(key, key.length);
    const fullKey = key + salt;
    oldDigest = Cript.sha1EsaDigest(fullKey, fullKey.length);
    key =
      Cript.trim(userName).toLowerCase() +
      Cript.trim(newPassword).toLowerCase();
    newDigest = Cript.sha1EsaDigest(key, key.length);
    activationCode = "";
  }
  const requestData: DigestChangePasswordRequest = {
    SecurityToken: securityToken,
    UserName: userName,
    Salt: salt,
    OldDigest: oldDigest === null ? "" : oldDigest,
    NewDigest: newDigest === null ? "" : newDigest,
    CodiceAttivazione: activationCode,
    Language: language,
  };
  try {
    const response: AxiosResponse<ChangePasswordResponse> = await apiClient({
      method: "post",
      url: "/Authentication/DigestChangePassword",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("ChangePassword Error:", error);
    throw error;
  }
};
